const loadVidyard = loadConfig => {
    const scriptID = 'vidyard-script';

    if (typeof vidyardEmbed === 'undefined' && !$(`#${scriptID}`).length)  {
        let file = 'v4.umd.js';

        if (loadConfig.isVidyardEmbed) {
            file = 'v4.js';
        }

        loadJS(`/public/js/external/vidyard/${file}`, loadConfig.onLoad, null, null, scriptID, false);
    } else {
        if (loadConfig.onLoad) {
            const interval = setInterval(() => {
                if (typeof vidyardEmbed !== 'undefined') {
                    clearInterval(interval);

                    loadConfig.onLoad();
                }
            }, 250);
        }
    }
};

const renderWithVidyardApi = videoData => {
    const code = videoData.code;
    const type = videoData.type || 'inline';

    vidyardEmbed.api.renderPlayer({
        uuid: code,
        container: videoData.container,
        type: type,
        aspect: 'landscape'
    }).then(videoData.onReady);
};

const renderVidyardPlayer = videoData => {
    if (typeof vidyardEmbed === 'undefined') {
        loadVidyard({
            isVidyardEmbed: videoData.isVidyardEmbed,
            onLoad: () => {
                renderWithVidyardApi(videoData);
            }
        });
    } else {
        renderWithVidyardApi(videoData);
    }
};

const renderEmbedVidyardPlayer = videoData => {
    videoData.isVidyardEmbed = true;
    
    renderVidyardPlayer(videoData);
};

export { loadVidyard, renderVidyardPlayer, renderEmbedVidyardPlayer };